<template>
    <a-tooltip :title="title">
        <a-button type="link" v-bind="$attrs" v-on="$listeners"></a-button>
    </a-tooltip>
</template>

<script>
    export default {
        name: "CardAction",
        props: {
            title: {
                type: String,
                required: true
            },
        },
    }
</script>

<style lang="less" scoped>
    button {
        width: 100%;
        height: auto;
        margin: 0;
        padding: 0;
        border: 0;
        color: rgba(0, 0, 0, 0.45);
    }

    button:focus {
        color: rgba(0, 0, 0, 0.45);
    }

    button:hover {
        color: rgba(0, 0, 0, 0.45);
    }
</style>
